import { HINTS, HINTS_STR, deleteHintParam } from './navigation/hints';

export const env = {
  apiBaseUrl: __API_BASE_URL__, // eslint-disable-line no-undef
  fileUploadUrl: __API_FILE_UPLOAD_URL__, // eslint-disable-line no-undef
  producerCode: __ABC__,  // eslint-disable-line no-undef
  producerCodeLimit: __ABC_LIMIT__,  // eslint-disable-line no-undef
  production: __PRODUCTION__,
  enableNavigation: __ENABLE_NAVIGATION__,
  servicePortalHost: __SERVICE_PORTAL_HOST__,
  gwPaymentSDKURL: __GW_PAYMENT_SDK_URL__,

  gooleAPI: __GOOGLE_API__,

  //credit payment configuration
  creditCardPaymentConfigId:__CREDIT_CARD_PAYMENT_CONFIG_ID__,
  creditCardPaymentTenant:__CREDIT_CARD_PAYMENT_TENANT__,
  creditCardPaymentApiUrl:__CREDIT_CARD_PAYMENT_API_URL__,

  ...HINTS
};

if (typeof env.production === 'string') {
  env.production = 'true' === env.production.toLocaleString();
}

export function deleteParam(name) {
  // First, drop from the env map
  delete env[name];
  // Then, extract it from the HINTS_STR string
  deleteHintParam(name);
}